<p
  class="component-container"
  [style]="{
    color: config().color,
    fontFamily: config().fontFamily,
    backgroundColor: config().backgroundColor,
  }"
  [innerHTML]="
    ((campaignEndDate() | daysLeft) === '1'
      ? config().defaultTemplate
      : config().plurielTemplate
    )
      | replaceVars: (campaignEndDate() | daysLeft) : false : '{daysLeft}'
      | replaceVars: (campaignEndDate() | date: 'dd/MM/yy')! : false : '{date}'
      | safe
  "
></p>
